const P1 =
  "M6 130H76C114 130 147 151 168 188L271 364C282 382 303 394 325 394H246C208 394 175 373 154 336L51 160C40 142 28 133 6 130Z";
const P2 =
  "M178 130H247C285 130 318 151 339 188L429 336C450 373 483 394 506 394H437C399 394 366 373 345 336L255 188C234 151 201 130 178 130Z";
const P3 =
  "M343 130H505L439 239C430 254 414 264 397 264C382 264 367 256 358 242L343 130Z";

type WorkScopeLoadingScreenProps = {
  className?: string;
  showWordmark?: boolean;
};

export function WorkScopeLoadingScreen({
  className = "",
  showWordmark = true,
}: WorkScopeLoadingScreenProps) {
  return (
    <div className={`flex min-h-[45vh] items-center justify-center ${className}`.trim()}>
      <style>{`
        @keyframes ws-logo-fade-up {
          0% { opacity: 0; transform: translateY(-18px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes ws-logo-draw {
          0% { stroke-dashoffset: 1100; fill-opacity: 0; }
          62% { stroke-dashoffset: 0; fill-opacity: 0; }
          100% { stroke-dashoffset: 0; fill-opacity: 1; }
        }
        @keyframes ws-logo-text {
          0%, 66% { opacity: 0; transform: translateY(12px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div
        className="flex flex-col items-center"
        style={{
          animation: "ws-logo-fade-up 560ms cubic-bezier(0.22, 1, 0.36, 1) both",
        }}
      >
        <svg width="126" height="100" viewBox="0 0 512 512" fill="none" aria-hidden="true">
          {[P1, P2, P3].map((path, index) => (
            <path
              key={index}
              d={path}
              fill="#F38C16"
              fillOpacity="0"
              stroke="#F38C16"
              strokeWidth="7"
              strokeDasharray="1100"
              strokeDashoffset="1100"
              style={{
                animation: "ws-logo-draw 2.4s cubic-bezier(0.22, 1, 0.36, 1) infinite",
              }}
            />
          ))}
        </svg>
        {showWordmark ? (
          <div
            className="mt-[-10px] text-[28px] font-bold tracking-[0.4px] text-[#0C1F4F]"
            style={{
              animation: "ws-logo-text 2.4s cubic-bezier(0.22, 1, 0.36, 1) infinite",
            }}
          >
            WorkScope
          </div>
        ) : null}
      </div>
    </div>
  );
}
